import { html, LitElement, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { HeaderItem } from '../types';

@customElement('gz-in-product-trials-header')
export class GzInProductTrialsHeaderWebComponent extends LitElement {
  @property({ type: Array, attribute: true, reflect: true })
  headerItems: Array<HeaderItem>;

  static get styles() {
    return styles;
  }

  render() {
    return html`<div class="in-product-trials-header">${this.renderHeader()}</div>`;
  }

  private renderHeader(): TemplateResult[] | undefined {
    if (!this.headerItems || !this.headerItems.length) {
      return;
    }

    // render text with medium font weight and body font size
    if (this.headerItems.length === 1) {
      return [html`<span id="in-product-trials-header-medium-body">${this.headerItems[0].text} </span>`];
    }

    const header: TemplateResult[] = [];
    // render text with normal font weight and heading4 font size
    for (let i = 0; i < this.headerItems.length - 1; i++) {
      if (!this.headerItems[i].onClickFunction) {
        header.push(html`<span id="in-product-trials-header-normal-heading4">${this.headerItems[i].text}</span>`);
      } else {
        header.push(
          html`<span id="in-product-trials-header-normal-heading4" @click="${this.headerItems[i].onClickFunction}"
            >${this.headerItems[i].text}</span
          >`
        );
      }
    }

    // render text with medium font weight and heading4 font size
    header.push(
      html`<span id="in-product-trials-header-medium-heading4"
        >${this.headerItems[this.headerItems.length - 1].text}</span
      >`
    );
    return header;
  }
}
